module.exports = __webpack_public_path__ + "img/github-black.7357f7a8.svg";